var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "user_3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD10-Login",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Parcours-1---choix-du-profil",
    transform: "translate(-963.000000, -356.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(862.000000, 310.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user_3",
    transform: "translate(101.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fillOpacity: 0.1,
    fill: "#EF855A",
    cx: 38,
    cy: 38,
    r: 38
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(18.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 35,
    x2: 35,
    y2: 35,
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "8.33333333 35 8.33333333 11.6666667 21.6666667 5 21.6666667 35"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "31.6666667 35 31.6666667 18.3333333 21.6666667 11.6666667"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 15,
    x2: 15,
    y2: 15.0166667,
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 20,
    x2: 15,
    y2: 20.0166667,
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 25,
    x2: 15,
    y2: 25.0166667,
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 30,
    x2: 15,
    y2: 30.0166667,
    id: "Path",
    stroke: "#EF855A",
    strokeWidth: 2.48,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser3);
export default __webpack_public_path__ + "static/media/user_3.afc9937a3515ea40c27d3ac299d4d23a.svg";
export { ForwardRef as ReactComponent };